// Static catalogue of social-login providers for the player frontend. The
// per-provider credentials (client_id, redirect_uri, scopes) come from the backend
// via /initial-settings signup_flow.social_logins.configured; this module only
// holds the code-level metadata a button needs: label, brand colour, icon glyph,
// the provider authorize endpoint, the flow shape, and whether PKCE is required.
//
// WhatsApp is intentionally absent: it is a messaging API, not a login provider.

export const SOCIAL_PROVIDERS = {
  google: {
    key: "google",
    label: "Google",
    flow: "token", // GIS returns an id_token client-side; we forward the raw token
    color: "#ffffff",
    textColor: "#3c4043",
    border: "#dadce0",
    icon: "google",
  },
  facebook: {
    key: "facebook",
    label: "Facebook",
    flow: "token", // FB SDK returns an access_token; we forward the raw token
    color: "#1877F2",
    textColor: "#ffffff",
    icon: "facebook",
  },
  discord: {
    key: "discord",
    label: "Discord",
    flow: "code",
    authorizeUrl: "https://discord.com/oauth2/authorize",
    needsPkce: false,
    color: "#5865F2",
    textColor: "#ffffff",
    icon: "discord",
  },
  twitch: {
    key: "twitch",
    label: "Twitch",
    flow: "code",
    authorizeUrl: "https://id.twitch.tv/oauth2/authorize",
    needsPkce: false,
    color: "#9146FF",
    textColor: "#ffffff",
    icon: "twitch",
  },
  kick: {
    key: "kick",
    label: "Kick",
    flow: "code",
    authorizeUrl: "https://id.kick.com/oauth/authorize",
    needsPkce: true, // Kick OAuth 2.1 requires PKCE (S256)
    color: "#53FC18",
    textColor: "#0b0b0b",
    icon: "kick",
  },
  x: {
    key: "x",
    label: "X",
    flow: "code",
    authorizeUrl: "https://twitter.com/i/oauth2/authorize",
    needsPkce: true, // X OAuth 2.0 with PKCE
    color: "#000000",
    textColor: "#ffffff",
    icon: "x",
  },
};

export function getProviderMeta(key) {
  if (!key) return null;
  return SOCIAL_PROVIDERS[String(key).toLowerCase()] || null;
}
